<template>
  <div class="invoice-view">
    <v-card flat>
      <v-container fluid>
        <!--          :pagination.sync="pagination" -->
        <v-data-table
          :headers="headers"
          :items="expenses"
          class="table-header"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              {{ props.item.enteredAt | moment("L LT") }}
            </td>
            <td class="text-xs-left">
              {{ props.item.Employee.name }}
            </td>
            <td data-cy="expenseComponentsListPayeeName" class="text-xs-left">
              {{ props.item.Payee ? props.item.Payee.name : "" }}
            </td>
            <td class="text-xs-left">
              <v-chip
                v-if="props.item.ExternalPaymentId"
                smal1l
                text-color="#5E687B"
                color="#DFE4EB"
              >
                <v-icon size="16" class="ml-1" left color="#5E687B"
                  >fas fa-cash-register</v-icon
                >
                <span>Register</span>
              </v-chip>
            </td>
            <td
              data-cy="expenseComponentsListAmount"
              class="text-right text-md-right text-sm-right text-lg-right"
            >
              {{ props.item.amount | currency }}
            </td>
          </template>
          <template slot="footer">
            <tr>
              <td :colspan="headers.length - 1">
                <div class="text-right font-weight-bold">
                  {{ $t("labels.total") }}
                </div>
              </td>
              <td class="text-right font-weight-bold">
                {{ total | currency }}
              </td>
            </tr>
          </template>
          <template slot="pagination"></template>
        </v-data-table>
      </v-container>
    </v-card>
    <!-- Total -->
  </div>
</template>

<script>
export default {
  props: ["selectedRange", "expenses", "showTotal"],
  data() {
    return {
      rowsPerPageItems: [10, 25, 50, 100],
      totalExpense: 0,
      isLoading: true,
      headers: [
        {
          text: this.$t("labels.date"),
          align: "left",
          sortable: false,
          value: "date",
          width: "20%",
        },
        {
          text: this.$t("labels.employeeName"),
          value: "employeeName",
          sortable: false,
        },
        {
          text: this.$t("labels.payeeName"),
          value: "payeeName",
          sortable: false,
        },
        {
          text: this.$t("labels.payFrom"),
          value: "payeeName",
          sortable: false,
        },
        {
          text: this.$t("labels.amount"),
          value: "amount",
          align: "right",
          sortable: false,
        },
      ],
      expenseDetailHeaders: [
        {
          text: this.$t("labels.date"),
          align: "left",
          sortable: false,
          value: "MasterCategories.createdAt",
        },
        {
          text: this.$t("labels.note"),
          align: "center",
          sortable: false,
          value: "MasterCategories.revenue",
        },
        {
          text: this.$t("labels.amount"),
          align: "right",
          sortable: false,
          value: "MasterCategories.revenue",
        },
      ],
    };
  },
  watch: {
    // search() {
    //   if (this.search.length > 3 || this.search.length === 0) {
    //     this.getList();
    //   }
    // },
    // pagination: {
    //   handler() {
    //     this.pagination.totalItems = this.count;
    //     this.getList();
    //   },
    //   deep: true,
    // },
  },
  computed: {
    total() {
      let total = 0;
      this.expenses.map((row) => {
        total += parseFloat(row.amount);
      });
      return total;
    },
  },
};
</script>
